<script setup lang="ts">
import type { PermissionSet } from '@/infrastructure/types';
import type { TagColor } from 'naive-ui/es/tag/src/common-props';

const props = defineProps<{
  permissionSet?: PermissionSet
}>()

const color = computed<TagColor | undefined>(() => {
  if (!props.permissionSet) return undefined

  return {
    color: props.permissionSet.color,
    textColor: props.permissionSet.textColor
  }
})
</script>

<template>
  <n-tag
    :color="color"
    :bordered="false"
    size="small"
    strong
  >
    {{ permissionSet?.name ?? 'Unknown' }}
  </n-tag>
</template>